import React from 'react';

const Daily1 = ({ selectedButton }) => {

  const buttonData = [
    // Data for Button 1
    {
      title: 'Rabbit: The Adorable Long-Eared Mammal',
      description: 'Rabbits are adorable mammals...',
      video: 'https://player.vimeo.com/external/401621673.sd.mp4?s=09e17e2af343546ed8d89ba2025616349ff25cfd&profile_id=165&oauth2_token_id=57447761',
      imageSrc: 'https://images.pexels.com/photos/4001296/pexels-photo-4001296.jpeg?auto=compress&cs=tinysrgb&w=600',
      infoList: [
        { label: 'Habitat:', value: 'Forest thickets, meadows, and woodland' },
        { label: 'Predators:', value: 'Foxes, wolves, bobcats, eagles, owls, coyotes' },
        { label: 'Average Litter:', value: '6' },
        { label: 'Lifestyle:', value: 'Group' },
        { label: 'Diet:', value: 'Herbivore' },
        { label: 'Food:', value: 'Clover, grass, crunchy vegetables' },
        { label: 'Favorite Food:', value: 'Clover' },
        { label: 'Color:', value: 'Brown, grey, black, white, tan' },
        { label: 'Skin Type:', value: 'Fur' },
        { label: 'Top Speed:', value: '2.4 mph' },
        { label: 'Life Span:', value: '4-9 years' },
        { label: 'Weight:', value: '0.5 - 3 kg' },
      ],
    },
    // Data for Button 2
    {
      title: 'Koala: The Cute and Cuddly Marsupial',
      description: 'Koalas are cute and cuddly...',
      video: 'https://player.vimeo.com/progressive_redirect/playback/784698419/rendition/360p/file.mp4?loc=external&oauth2_token_id=57447761&signature=779334a0622cf78b82641c61f924659d718817311514c509aa43637467570c17',
      imageSrc: 'https://images.pexels.com/photos/1770706/pexels-photo-1770706.jpeg?auto=compress&cs=tinysrgb&w=600',
      infoList: [
        { label: 'Habitat:', value: 'Eastern Australia (eucalyptus forests)' },
        { label: 'Predators:', value: 'Humans and introduced species (dogs, cars)' },
        { label: 'Average Litter:', value: '1 joey' },
        { label: 'Lifestyle:', value: 'Solitary or small groups' },
        { label: 'Diet:', value: 'Eucalyptus leaves' },
        { label: 'Food:', value: 'Eucalyptus leaves' },
        { label: 'Favorite Food:', value: 'Eucalyptus leaves (primary diet)' },
        { label: 'Color:', value: 'Gray with white markings' },
        { label: 'Skin Type:', value: 'Fur' },
        { label: 'Top Speed:', value: '20 mph (sprint)' },
        { label: 'Life Span:', value: '13 - 18 years in the wild, up to 20 years in captivity' },
        { label: 'Weight:', value: '4 - 15 kg (adults)' },
      ],
    },
    // Data for Button 3
    {
      title: 'Panda: The Adorable Bamboo Eater',
      description: 'Pandas are known for...',
      video: 'https://player.vimeo.com/progressive_redirect/playback/735107171/rendition/360p/file.mp4?loc=external&oauth2_token_id=57447761&signature=24ed9a45ea9eb9087a530dbcd2431c5e29db0517ce49250a3d5cfe89e91fde51',
      imageSrc: 'https://images.pexels.com/photos/3608263/pexels-photo-3608263.jpeg?auto=compress&cs=tinysrgb&w=600',
      infoList: [ 
      { label: 'Habitat:', value: 'Mountainous regions of central China' },
      { label: 'Predators:', value: 'None in the wild (adults have no natural predators)' },
      { label: 'Average Litter:', value: '1 or 2 cubs' },
      { label: 'Lifestyle:', value: 'Solitary' },
      { label: 'Diet:', value: 'Primarily bamboo, but also eat small mammals, birds, and eggs' },
      { label: 'Food:', value: 'Bamboo, small mammals, birds, eggs' },
      { label: 'Favorite Food:', value: 'Bamboo' },
      { label: 'Color:', value: 'Black and white' },
      { label: 'Skin Type:', value: 'Fur' },
      { label: 'Top Speed:', value: '20 mph (sprint)' },
      { label: 'Life Span:', value: '20 years in the wild, up to 30 years in captivity' },
      { label: 'Weight:', value: '70 - 150 kg (adults)' },
    ],
    },
    // Data for Button 4
    {
      title: 'Hedgehog: The Spiky Insect Eater',
      description: 'Hedgehogs are small...',
      video: 'https://player.vimeo.com/external/637382686.sd.mp4?s=653cd64b6edc0275a058d3360bc2499ede332313&profile_id=164&oauth2_token_id=57447761',
      imageSrc: 'https://images.pexels.com/photos/50577/hedgehog-animal-baby-cute-50577.jpeg?auto=compress&cs=tinysrgb&w=600',
      infoList: [
        { label: 'Habitat:', value: 'Africa, Asia, Eurasia, Europe' },
        { label: 'Predators:', value: 'Humans, dogs, foxes, and birds of prey' },
        { label: 'Average Litter:', value: '4 - 5 hoglets' },
        { label: 'Lifestyle:', value: 'Solitary' },
        { label: 'Diet:', value: 'Insects, small rodents, frogs, and eggs' },
        { label: 'Food:', value: 'Insects, small rodents, frogs, and eggs' },
        { label: 'Favorite Food:', value: 'Insects (such as beetles and caterpillars)' },
        { label: 'Color:', value: 'Brown with light spines' },
        { label: 'Skin Type:', value: 'Spines and fur' },
        { label: 'Top Speed:', value: '5 mph (sprint)' },
        { label: 'Life Span:', value: '2 - 5 years in the wild, up to 8 years in captivity' },
        { label: 'Weight:', value: '500 - 1,500 grams (adults)' },
      ],
    },
    // Will add data for other buttons here
  ];

  // selectedButton index to display the content for the selected button
  const selectedButtonData = buttonData[selectedButton];

  return (
    <>
      <div className="untree_co-section">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6">
              <figure className="img-play-video">
              <a id="play-video" className="video-play-button" href={selectedButtonData.video} data-fancybox>						
                <span></span>
                </a>
                {/* Display the selected image */}
                <div className="display_animal_flex">
                  <img src={selectedButtonData.imageSrc} alt="Image" className="mx-auto img-fluid rounded-20" />
                </div>
              </figure>
            </div>

            <div className="col-lg-5">
              {/* Display the selected title and description */}
              <h2 className="section-title text-left mb-4">{selectedButtonData.title}</h2>
              <p className="text-justify">{selectedButtonData.description}</p>

              {/* Display the selected info list */}
              <ul className="list-unstyled two-col clearfix info_daily_animal">
                {selectedButtonData.infoList.map((item, index) => (
                  <li key={index}>
                    <span>{item.label}</span> {item.value}
                  </li>
                ))}
              </ul>

              <p>
                <a href="#" className="btn btn-primary">
                  Know More
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Daily1;
